






















import { Component, Prop, Vue } from 'vue-property-decorator'

import Booking from '@/models/booking'
import { BookingStatusBarTypes } from '@/models/booking-status-bar'
import PaymentModalSteps from '@/models/payment-modal-steps'

enum PaymentModalMessageTypes {
  TotalAmount = 'totalamount',
  DepositLeft = 'depositLeft',
}

@Component({
  components: {},
})
export default class PaymentModalTopMessage extends Vue {
  @Prop() booking!: Booking
  @Prop() total!: number
  @Prop() currentStep!: PaymentModalSteps

  initialSetupInProgress = true

  get topMessage(): PaymentModalMessageTypes | null {
    const { totalPaymentMessageisVisible, depositMessageIsVisible } = this

    switch (true) {
      case totalPaymentMessageisVisible:
        return PaymentModalMessageTypes.TotalAmount
      case depositMessageIsVisible:
        return PaymentModalMessageTypes.DepositLeft
      default:
        return null
    }
  }

  get totalPaymentMessageisVisible() {
    return this.currentStep === PaymentModalSteps.Enroll
  }

  get depositMessageIsVisible(): boolean {
    const {
      currentStep,
      booking: { bookingStatusBar, depositRemainingCents },
    } = this

    const excludedStatuses = [
      BookingStatusBarTypes.Cancelled,
      BookingStatusBarTypes.Expired,
      BookingStatusBarTypes.FullPaymentOverdue,
      BookingStatusBarTypes.FullPaymentRequired,
      BookingStatusBarTypes.SecureBookingFullPayment,
    ]

    return (
      !excludedStatuses.includes(bookingStatusBar?.type) &&
      currentStep === PaymentModalSteps.Amount &&
      depositRemainingCents > 0
    )
  }

  get messageTypes() {
    return PaymentModalMessageTypes
  }

  get steps() {
    return PaymentModalSteps
  }
}
